export const selectCustomTags = state => state.customTags;
